import React from 'react';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import styled from 'styled-components';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';

import {
  StyledTableHeadRow,
  StyledTableBodyRow,
  StyledTableCell,
} from '@ui-elements/styled/StyledTable';
import Button from '@ui-elements/Button';
import BasicModal from '@ui-parts/BasicModal';

import { SurveyRejectReason } from '@mytypes';
import { FONT_SIZES } from '~/assets/styles/base';

const StyledTable = styled(Table)`
  th {
    font-size: ${FONT_SIZES.body3};
  }
  td {
    font-size: ${FONT_SIZES.body3};
    vertical-align: top;
    text-align: left;
    white-space: pre-wrap;
  }
`;

type Props = {
  open: boolean;
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  history: SurveyRejectReason[];
};
const SurveyRejectReasonModal: React.FC<Props> = ({ open, handleClose, history }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <BasicModal
      open={open}
      titleProps={{
        titleLabel: t('adminSurvey.JudgementBox.surveyRejectReasonModal.title'),
      }}
      handleClose={handleClose}
      buttons={[
        <div key="ModalFooterInner">
          <Button
            onClick={handleClose}
            colorType="gray"
            width="150px"
            dataTestId="SurveyRejectReasonModal-Back"
          >
            {t('appCommon.back')}
          </Button>
        </div>,
      ]}
      disableAutoFocus
      dataTestId="SurveyRejectReasonModal"
      width="80%"
    >
      <TableContainer component="div">
        <StyledTable data-testid="SurveyRejectReasonModalTable">
          <TableHead>
            <StyledTableHeadRow>
              <StyledTableCell align="left" sx={{ width: '20%' }}>
                {t('adminSurvey.JudgementBox.surveyRejectReasonModal.tableHeader.date')}
              </StyledTableCell>
              <StyledTableCell align="left" sx={{ width: '20%' }}>
                {t('adminSurvey.JudgementBox.surveyRejectReasonModal.tableHeader.categories')}
              </StyledTableCell>
              <StyledTableCell align="left">
                {t('adminSurvey.JudgementBox.surveyRejectReasonModal.tableHeader.reason')}
              </StyledTableCell>
            </StyledTableHeadRow>
          </TableHead>

          <TableBody>
            {history.map((surveyRejectReason, i) => (
              <StyledTableBodyRow key={surveyRejectReason.rejectDate} $index={i}>
                <StyledTableCell>
                  {format(parseISO(surveyRejectReason.rejectDate), 'yyyy/MM/dd HH:mm')}
                </StyledTableCell>
                <StyledTableCell>{surveyRejectReason.rejectCategories.join('\n')}</StyledTableCell>
                <StyledTableCell>{surveyRejectReason.rejectReason}</StyledTableCell>
              </StyledTableBodyRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </BasicModal>
  );
};

export default SurveyRejectReasonModal;
